var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from "react";
import { isAddress } from "ethers/lib/utils";
import axios from "axios";
import { useWeb3React } from "@web3-react/core";
import { CHAINID, getENSSubgraphURI, isDevelopment } from "../utils/env";
import { useWeb3Context } from "./web3Context";
var useENSSearch = function (searchString) {
    var provider = useWeb3Context().provider;
    var chainId = useWeb3React().chainId;
    var _a = useState(), result = _a[0], setResult = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(0), setCounter = _c[1];
    var searchResult = useCallback(function (_provider, _searchString) { return __awaiter(void 0, void 0, void 0, function () {
        var currentCount, data, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    /**
                     * Kovan does not support ENS
                     * When wallet are not connect, it uses mainnet therefore we can perform search.
                     */
                    if (isDevelopment() || chainId !== CHAINID.ETH_MAINNET) {
                        setResult(isAddress(_searchString)
                            ? { address: _searchString, texts: [] }
                            : undefined);
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    setCounter(function (prev) {
                        currentCount = prev + 1;
                        /**
                         * Set address or refresh result on search string change before doing the search
                         */
                        setResult(isAddress(_searchString)
                            ? { address: _searchString, texts: [] }
                            : undefined);
                        return prev + 1;
                    });
                    _a = fetchSearchFromENSSubgraph;
                    if (!isAddress(_searchString)) return [3 /*break*/, 2];
                    return [4 /*yield*/, _provider.lookupAddress(_searchString)];
                case 1:
                    _b = (_c.sent()) || "";
                    return [3 /*break*/, 3];
                case 2:
                    _b = _searchString;
                    _c.label = 3;
                case 3: return [4 /*yield*/, _a.apply(void 0, [_b])];
                case 4:
                    data = _c.sent();
                    setCounter(function (prev) {
                        if (prev === currentCount) {
                            /**
                             * If no result, we merely either set result to empty or set address
                             */
                            if (data.length <= 0) {
                                setResult(isAddress(_searchString)
                                    ? { address: _searchString, texts: [] }
                                    : undefined);
                            }
                            else {
                                var firstResult = data[0];
                                setResult({
                                    address: firstResult.owner.id,
                                    name: firstResult.name,
                                    labelName: firstResult.labelName,
                                    texts: firstResult.resolver.texts || [],
                                });
                            }
                            setLoading(false);
                        }
                        return prev;
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [chainId]);
    useEffect(function () {
        searchResult(provider, searchString);
    }, [provider, searchResult, searchString]);
    /**
     * Lazy Fetch avatar
     */
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var resolver, avatarURL_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(result &&
                            result.name &&
                            result.texts.includes("avatar") &&
                            !result.avatar)) return [3 /*break*/, 3];
                        return [4 /*yield*/, provider.getResolver(result.name)];
                    case 1:
                        resolver = _a.sent();
                        if (!resolver) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, resolver.getText("avatar")];
                    case 2:
                        avatarURL_1 = _a.sent();
                        setResult(function (prev) {
                            return prev
                                ? __assign(__assign({}, prev), { avatar: avatarURL_1 }) : undefined;
                        });
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); })();
    }, [provider, result]);
    return { data: result, loading: loading };
};
var fetchSearchFromENSSubgraph = function (searchString) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios.post(getENSSubgraphURI(), {
                    query: "{\n      domains(\n        where: {name: \"" + searchString + "\"}\n      ){\n        name\n        labelName\n        resolver {\n          texts\n        }\n        owner {\n          id\n        }\n      }\n    }",
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data.domains];
        }
    });
}); };
export default useENSSearch;
//# sourceMappingURL=useENSSearch.js.map